export const RUNTIME_RECOVERY_STATE_KEY: string = 'lu_runtime_recovery_state_v1';

export const RUNTIME_RECOVERY_DEFAULT_THROTTLE_MS: number = 60000;
export const RUNTIME_RECOVERY_DEFAULT_MAX_ATTEMPTS: number = 2;
export const RUNTIME_RECOVERY_SECOND_ATTEMPT_DELAY_MS: number = 2000;

export const RUNTIME_RECOVERY_GLOBAL_API_KEY: string = '__luRuntimeRecovery';
export const RUNTIME_RECOVERY_FALLBACK_ID: string = 'lu-runtime-recovery-fallback';

export const RUNTIME_RECOVERY_RECOVERABLE_REASONS: ReadonlyArray<string> = [
  'chunk_load',
  'bootstrap_error',
  'qrator_auth',
];
